<template>
  <div class="c-wallet-transaction-progress">
    <div class="c-wallet-transaction-progress__bar">
      <span
        class="c-wallet-transaction-progress__bar--percent"
        :style="{ width: value + '%' }"
      ></span>
    </div>
    <small>{{ value }}%</small>
  </div>
</template>

<script>
export default {
  props: {
    valuePercent: {
      type: String,
      required: true,
    },
  },
  computed: {
    value() {
      return parseInt(this.valuePercent)
    },
  },
}
</script>

<style lang="scss">
.c-wallet-transaction-progress {
  display: inline-flex;
  align-items: center;

  &__bar {
    display: inline-block;
    height: 4px;
    width: 30px;
    margin: 0 4px;
    border-radius: 2px;
    background-color: $gray-4;
    position: relative;

    @media (min-width: $tablet) {
      width: 70px;
      margin: 0 8px;
    }

    &--percent {
      background-color: $support;
      position: absolute;
      border-radius: 2px;
      max-width: 100%;
      height: 100%;
      bottom: 0;
      width: 0;
      left: 0;
      top: 0;
    }
  }
}
</style>
